/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BArticleDto } from './articleDto';


export interface B2BArticlePriceDto { 
    id?: number;
    price?: number | null;
    conventionalPrice?: number | null;
    point?: number | null;
    isFree?: boolean;
    rating?: number | null;
    articleId?: number;
    article?: B2BArticleDto;
}

